import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { environment } from '@environment/environment';
import { SecurityService } from '@shared/services';
import { ResourcesService } from '@shared/services/resources.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { first, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-resource-details-popup',
  templateUrl: './resource-details-popup.component.html',
  styleUrls: ['./resource-details-popup.component.scss']
})
export class ResourceDetailsPopupComponent implements OnInit {

  constructor(private modalService: BsModalService, private secSerive:SecurityService,
     private _resourceService: ResourcesService,
  ) { }

  ngOnInit(): void {
    this.GetResourceFavList();
  }


   @ViewChild('resourceInfoModal', { static: true }) resourceModal: TemplateRef<any>;
    private _unsubscribeAll$ = new Subject<void>(); 
    currentResource : any;

       openModal(resId) {
          
          this.getResourceById(resId);
        const configs = {
                keyboard: false,
                ignoreBackdropClick: true,
                class: ' modal-lg modal-primary  ModelPopUpLayoutFilterPopUps commenModel  fadeInCenter',
                animated: false
            };
            this.modalRef = this.modalService.show(this.resourceModal, configs);
          
        }
         modalRef: BsModalRef | null;
  
          closeResourceDetailsModal() {
          this.modalRef.hide();
      }

      getResourceById(resId){
        this._resourceService
              .getresourcebyid(resId)
              .pipe(takeUntil(this._unsubscribeAll$), first())
              .subscribe(
                (result) => {
                  this.currentResource = result.data;
                  console.log('Resource load', this.currentResource);
                },
                (error) => {
                  console.error('Error fetching contact:', error);
                }
              );

      }

      ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  ResourceFav:any

  ManageFav(item)
  {
    debugger
    if(this.checkIsFav(item))
      this.removeResourceFromFav(item)
    else{
      this.AddLoactionToFav(item);
    }
  }

 checkIsFav(item):boolean
  {
    if(this.ResourceFav)
    if(this.ResourceFav.find(e=>e.resourceId== item.resourceId))
      return true;
    else
       return false;
  }
   AddLoactionToFav(item)
  {
  // Check if already exists (optional)
    const exists = this.ResourceFav.some(fav => fav.resourceId === item.resourceId);

    if (!exists) {
      this.ResourceFav.push({
        userId: this.secSerive.securityObject.userId,
        ResourceId: item.resourceId,
        ResourceName: item.ResourceName
      });
    }
    this._resourceService
    .AddToFav(item)
    .pipe(takeUntil(this._unsubscribeAll$), first())
    .subscribe((result) => {
       this.GetResourceFavList();
    });
    
  }
  removeResourceFromFav(item)
  {
    // Check if already exists (optional)
    const index = this.ResourceFav.findIndex(fav => fav.resourceId === item.resourceId);
    if (index != -1) {
      this.ResourceFav.splice(index, 1);
    }

    this._resourceService
    .RemoveFromFav([item])
    .pipe(takeUntil(this._unsubscribeAll$), first())
    .subscribe((result) => {
      this.GetResourceFavList();
    });
    
  }
  ResourceList:any
  GetResourceFavList()
  {
    this._resourceService
    .getFavList()
    .pipe(takeUntil(this._unsubscribeAll$), first())
    .subscribe((result) => {
      this.ResourceFav=result.data;
    });
    
  }
}
